import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdateTypeState } from './update-type.state';
import { NgxsModule } from '@ngxs/store';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NgxsModule.forFeature([UpdateTypeState])
  ]
})
export class UpdatetypeStoreModule { }
